<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hklr.fctitaal_oms}} {{hklr.hklr_bedrag}} from booking {{hklr.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHklr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hklr_encrid: null,
      hklr: {}
    }
  },
  methods: {
    open(hklr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHklr"
          },
          getHklr: {
            hklr_encrid: hklr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hklr = res.data.getHklr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHklr() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/rmHklr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHklr"
          },
          rmHklr: {
            hklr_encrid: this.hklr.hklr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmHklr.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHklr.text,
              color: res.data.rmHklr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

